/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./card-docs-styles.css";

const CardLink = (props) => {
  return (
    <React.Fragment>
      <section className="card-docs-container">
        <div className="card-docs-content">
          <p>{props.nome}</p>
          <div className="card-docs-content-info">
            {props.link != null ? (
              <a
                className="card-docs-download"
                href={`${props.link}`}
                target="_blank"
                rel="noreferrer"
                aria-label={`Acesso a ${props.nome}`}
              >
                <i className="material-icons" aria-hidden="true">
                  open_in_new
                </i>
              </a>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default CardLink;
